import { AutoScrollBehavior } from "../Behaviors";
import { Assembly3DViewer } from "./Assembly3DViewer";
import { UserDefinedFunctionButton } from "./Button";
import { CadClickCadBox } from "./CadClickUiControls";
import { CadClickViewer3D } from "./CadClickViewer3D";
import { Divider } from "./Divider";
import { OtherComponentType } from "./OtherComponentType";
import { Spacer } from "./Spacer";
/**
 * Values must start with value to be picked up by the renderer
 */
export const OtherComponents = {
    [OtherComponentType.Assembly3DViewer]: Assembly3DViewer,
    [OtherComponentType.CadClickViewer3D]: CadClickViewer3D,
    [OtherComponentType.CadClickCadBox]: CadClickCadBox,
    [OtherComponentType.AutoScrollBehavior]: AutoScrollBehavior,
    [OtherComponentType.UserDefinedFunctionButton]: UserDefinedFunctionButton,
    [OtherComponentType.Spacer]: Spacer,
    [OtherComponentType.Divider]: Divider,
};
//# sourceMappingURL=OtherComponents.js.map